import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { MyUtils } from "../../../services/my-utils.service";
import { InterviewDetail } from "../table-links-modal/models/interview-details";
import { InterviewDetailsMapper } from "./interview-detail-mapper.service";
import { AuthService } from "src/app/services/auth.service";
import { ApplicationService } from "src/app/services/application.service";
import { DataMiningService } from "src/app/services/data-mining.service";
import { FormControl, FormGroup } from "@angular/forms";


interface DetailSection {
  data: Record<string, string>,
  icon: string,
  title: string,
}
interface CustomerData extends Record<string, string> {
  "FirstName": string,
  "LastName": string,
  "Phone": string,
  "Region": string,
  "Dealer": string,
  "Market": string,
  "agent": string,
  "Importer": string,
  "E-mail": string,
  "outletName": string,
}
interface EuropeanCustomerData extends Omit<CustomerData, 'Dealer' | 'agent'> {
  "Importer": string,
  "Main": string,
  "Network": string,
  "Outlet": string
}

interface VehicleData extends Record<string, string> {
  "Brand": string,
  "Vin": string,
  "Model": string,
  "Engine Type": string,
  "Vehicle Type": string,
}

interface SurveyData extends Record<string, string> {
  "responseChannel": string,
  "responseDate": string,
  "eventDate": string,
}
interface CaseData extends Record<string, string> {
  "caseNumber": string,
  "interviewType": string,
  "importer": string,
  "dealerCec": string,
  "Opened": string,
  "Closed": string
}

@Component({
  selector: "app-interview-detail",
  templateUrl: "./interview-detail.component.html",
  styleUrls: ["./interview-detail.component.scss"],
})
export class InterviewDetailComponent implements OnChanges {
  @Input() questions: InterviewDetail[] = [];
  @Input() interviewDetail!: InterviewDetail;
  
  data: DetailSection[] = [];
  tableData: { answer: string; question: string;questiontype:string }[] = []
  verbatim!: InterviewDetail | null;
  isCEC: boolean;
  dataMiningForm: FormGroup | null = null;
  showDataMining: boolean = false;

  constructor(public utils: MyUtils,
    private applicationService: ApplicationService,
    private mapper: InterviewDetailsMapper,
    private dataMiningService: DataMiningService) {
    this.isCEC = this.applicationService.navBarSelectValue?.idItem.includes('CEC') ?? false;
  }

  ngOnChanges(): void {
    this.initDetails();
    if (this.isCEC && !!this.interviewDetail.surveyRequestId) {
      this.getDataMiningData();
    }
  }

  private initDetails() {
    const details = this.isCEC ? this.mapper.mapCecInterviewDetails(this.interviewDetail) : this.mapper.mapInterviewDetails(this.interviewDetail)
    if (this.isCEC) {
      const verbatim = this.getVerbatim(this.questions);
      if (verbatim) {
        this.verbatim = verbatim;
        this.questions.splice(this.questions.indexOf(verbatim));
      }
    }

    this.tableData = this.questions.map((q) => {
      let mappedQuestion;

      switch(q.questionType){
        case "CheckBoxChoice":
        case "CheckBoxChoiceMultiple":
          let answer = (q.mappedAnswer === '###' || (!q.mappedAnswer.startsWith("c")&& !q.mappedAnswer.startsWith("n")))
            ? q.mappedAnswer
            : q.questionCode + q.mappedAnswer;
          mappedQuestion = {
            question: q.questionCode + ":title",
            answer: answer,
            questiontype:q.questionType,
            };        
          break;
          case "MultipleOptionChoice":
            let answerOption = (!!q.multipleChoice)
              ? q.multipleChoice
              : this.utils.traslatei18n(q.questionCode+"0");
            mappedQuestion = {
              question: q.questionCode + ":title",
              answer: answerOption,
              questiontype:q.questionType,
              };        
            break;        
        case "RadioChoice":
          let answerRadio = q.mappedAnswer.toLowerCase().includes(q.questionCode.toLowerCase()) 
          ? q.mappedAnswer : 
          q.questionCode + q.mappedAnswer;
            mappedQuestion = {
              question: q.questionCode + ":title",
              answer: answerRadio,
              questiontype:q.questionType,
              };        
            break;
        default:
          mappedQuestion = {
            question: q.questionCode + ":title",
            answer: q.mappedAnswer,
            questiontype:q.questionType,
            };
      }
      return mappedQuestion;
    });

    this.data = [
      {
        data: details.get('customerData')!,
        icon: "perm_identity",
        title: "CustomerDetails",
      },
      {
        data: details.get('vehicleData')!,
        icon: "directions_car",
        title: "vehicle_details",
      },
      {
        data: details.get('surveyData')!,
        icon: "event_note",
        title: "surveyDetails",
      },
    ];

    if (this.isCEC) {
      this.data.push({
        data: details.get('caseData')!,
        icon: "event_note",
        title: "Case Details",
      })
    }
  }

  controlSplit(answer: string, questionCode: string) {
    if (answer == '0') {
      return this.utils.traslatei18n(questionCode.replace(':title', '0'));
    }
    let split = (answer ?? '').split('*');
    if (split.length > 1) {
      let newAnswer = '';
      split.forEach(item => {
        newAnswer = newAnswer + this.utils.traslatei18n(item) + ' - ';
      })
      return newAnswer;
    } else {
      return this.utils.traslatei18n(answer);
    }
  }

  getLabels(object: Record<string, string>): string[] {
    return Object.keys(object);
  }

  getVerbatim(data: InterviewDetail[]): InterviewDetail | null {
    return data.find(x => x.questionCode.match(/^.*_v$/)) ?? null;

  }

  getDataMiningData() {
    this.dataMiningService.getDataMiningDetails(this.interviewDetail.surveyRequestId, this.applicationService.navBarSelectValue.idItem)
      .subscribe(response => {
        if (!!response['recoveryPlanId']) {
          this.showDataMining = true;
          this.dataMiningForm = new FormGroup({
            contactReasonL1: new FormControl(response['contactReasonL1']),
            contactReasonL2: new FormControl(response['contactReasonL2']),
            dissatisfacionReason1Level1: new FormControl(response['dissatisfacionReason1Level1']),
            dissatisfacionReason1Level2: new FormControl(response['dissatisfacionReason1Level2']),
            dissatisfacionReason2Level1: new FormControl(response['dissatisfacionReason2Level1']),
            dissatisfacionReason2Level2: new FormControl(response['dissatisfacionReason2Level2']),
            personEnteringInfo: new FormControl(response['personEnteringInfo']),
            description: new FormControl(response['description']),
            dtStart: new FormControl(new Date(response['dtStart']))
          })
          this.dataMiningForm.disable()
        }
      })
  }
}
